import React, { forwardRef } from 'react'

import { DatePicker } from 'antd'

import styles from './styles.module.scss'

import type { ForwardRefRenderFunction } from 'react'
import type { Dayjs } from 'dayjs'
import type { RangePickerRef } from 'antd/es/date-picker/generatePicker/interface'
import type { LntRangeDatePickerProps } from './types'

const separator = <div className={ styles.lntRangeDatePicker__separator } />

const Component: ForwardRefRenderFunction<RangePickerRef<Dayjs>, LntRangeDatePickerProps> = (props, ref) => {
  return (
    <DatePicker.RangePicker
      { ...props }
      separator={ separator }
      ref={ ref as RangePickerRef<Dayjs> }
    />
  )
}

export const LntRangeDatePicker = forwardRef<RangePickerRef<Dayjs>, LntRangeDatePickerProps>(Component)
